import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabNavigationService } from '../../../services/tab-navigation.service';
import { ScrollService } from '../../../services/page-scroll.service';
@Component({
    selector: 'app-step-2',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step-2.component.html',
    styleUrl: './step-2.component.scss',
})
export class Step2Component implements OnChanges {
    @Input() data: any;
    checklist: any = [];
    gaId: any = '';
    constructor(
        private tabNavigationService: TabNavigationService,
        private scrollService: ScrollService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            const chData = changes?.data?.currentValue;
            this.gaId = chData?.switcher1group + '_download_button_jc3_click';
            for (let i = 1; i <= 10; i++) {
                if (chData[`checklist${i}`]) {
                    this.checklist.push(chData[`checklist${i}`]);
                }
            }
        }
    }

    navigateToTabs(mainTab: string, subTab: string) {
        this.tabNavigationService.navigateToTab(mainTab, subTab);
    }

    scrollToTop() {
        this.scrollService.scrollToPosition(0, 'smooth');
    }
    planList = [
        'Shortlist the 3 most critical sustainability themes that your company needs to focus on (including Emissions Management*).',
        'Adopt suitable measurement(s) to assess current performance or impacts. Based on chosen measures, collect the relevant ESG data to monitor progress.',
        'Identify suitable initiatives to undertake under each theme and develop a simple action plan (for examples, please refer to the table below)',
    ];
}
